import { createRoot } from 'react-dom/client';

// style.css
import './assets/style.css';

// basic styles only

// fonts will be loaded via CSS or CDN

// font imports
import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';

// project imports
import App from './App';
import { ConfigProvider } from './contexts/ConfigContext';
import { getSiteBrand } from './utils/environment';
import faviconDev from './assets/images/favicon-dev.png';
import faviconTest from './assets/images/favicon-test.png';

// index.html hardcodes the green favicon; Test/Dev are switched at runtime by hostname.
const siteBrand = getSiteBrand();
const faviconOverride = siteBrand === 'test' ? faviconTest : siteBrand === 'dev' ? faviconDev : null;
if (faviconOverride) {
  document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]').forEach((link) => {
    link.href = faviconOverride;
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);
